module.exports = __webpack_public_path__ + "img/life.64a586ff.webp";